import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    cancelLabel: 'Cancel',
    saveLabel: 'Save',
    submitLabel: 'Submit',
  },
})
